import { Col, Container, Row } from 'react-bootstrap';
import { Post2 } from 'components/blog';

type HeroProps = {
    post: Post2 | null;
};

const Hero = ({ post }: HeroProps) => {
    return (
        <section
            className="position-relative overflow-hidden"
            style={{
                background: 'linear-gradient(135deg, #f0f4ff 10%, #e8f7f8 50%, #f5f0ff 120%)',
                borderBottom: '1px solid #e5e7eb',
                paddingTop: '100px',
                paddingBottom: '48px',
                marginBottom: '50px',
            }}
        >
            {/* Decorative background elements */}
            {/* Large soft circle — top right */}
            <div
                style={{
                    position: 'absolute',
                    top: '-60px',
                    right: '-40px',
                    width: '280px',
                    height: '280px',
                    borderRadius: '50%',
                    background: 'rgba(38,162,171,0.07)',
                    pointerEvents: 'none',
                }}
            />
            {/* Small circle — bottom left */}
            <div
                style={{
                    position: 'absolute',
                    bottom: '-30px',
                    left: '5%',
                    width: '140px',
                    height: '140px',
                    borderRadius: '50%',
                    background: 'rgba(36,52,125,0.05)',
                    pointerEvents: 'none',
                }}
            />
            {/* Dots grid pattern — top left */}
            <svg
                style={{ position: 'absolute', top: '30px', left: '3%', opacity: 0.12, pointerEvents: 'none' }}
                width="80" height="80" viewBox="0 0 80 80" fill="none"
            >
                {[0, 20, 40, 60].map(x =>
                    [0, 20, 40, 60].map(y => (
                        <circle key={`${x}-${y}`} cx={x + 4} cy={y + 4} r="2.5" fill="#26A2AB" />
                    ))
                )}
            </svg>
            {/* Dots grid pattern — bottom right */}
            <svg
                style={{ position: 'absolute', bottom: '20px', right: '4%', opacity: 0.1, pointerEvents: 'none' }}
                width="60" height="60" viewBox="0 0 60 60" fill="none"
            >
                {[0, 20, 40].map(x =>
                    [0, 20, 40].map(y => (
                        <circle key={`${x}-${y}`} cx={x + 4} cy={y + 4} r="2" fill="#24347D" />
                    ))
                )}
            </svg>
            {/* Decorative ring — mid right */}
            <svg
                style={{ position: 'absolute', top: '40%', right: '8%', opacity: 0.08, pointerEvents: 'none' }}
                width="90" height="90" viewBox="0 0 90 90" fill="none"
            >
                <circle cx="45" cy="45" r="40" stroke="#24347D" strokeWidth="3" fill="none" />
            </svg>
            {/* Small diamond — left side */}
            <svg
                style={{ position: 'absolute', top: '55%', left: '8%', opacity: 0.1, pointerEvents: 'none' }}
                width="24" height="24" viewBox="0 0 24 24" fill="none"
            >
                <rect x="12" y="0" width="16" height="16" rx="2" transform="rotate(45 12 0)" fill="#26A2AB" />
            </svg>

            <Container className="position-relative" style={{ zIndex: 1 }}>
                <Row className="justify-content-center">
                    <Col lg={10} xl={8}>
                        {/* Breadcrumb-style tag */}
                        {post?.blogTags && (
                            <div className="mb-3 d-flex align-items-center" style={{ gap: '8px' }}>
                                <span style={{ width: '28px', height: '2px', background: '#26A2AB', display: 'inline-block' }} />
                                <span
                                    style={{
                                        fontSize: '0.78rem',
                                        fontWeight: 600,
                                        letterSpacing: '1.5px',
                                        textTransform: 'uppercase',
                                        color: '#26A2AB',
                                    }}
                                >
                                    {post.blogTags}
                                </span>
                            </div>
                        )}

                        {/* Title */}
                        <h1
                            style={{
                                fontSize: 'clamp(1.5rem, 3.5vw, 2.4rem)',
                                fontWeight: 800,
                                lineHeight: 1.3,
                                color: '#1a1a2e',
                                marginBottom: '20px',
                            }}
                        >
                            {post?.blogTitle}
                        </h1>

                        {/* Meta info row */}
                        <div className="d-flex flex-wrap align-items-center" style={{ gap: '16px' }}>
                            {post?.createdOn && (
                                <span
                                    style={{
                                        fontSize: '0.88rem',
                                        color: '#6b7280',
                                    }}
                                >
                                    {new Intl.DateTimeFormat("en-US", {
                                        day: "numeric",
                                        month: "long",
                                        year: "numeric",
                                    }).format(new Date(post.createdOn))}
                                </span>
                            )}
                            {post?.longDescription && (
                                <>
                                    <span style={{ color: '#d1d5db' }}>|</span>
                                    <span style={{ fontSize: '0.88rem', color: '#6b7280' }}>
                                        {Math.max(1, Math.ceil(post.longDescription.replace(/<[^>]*>/g, '').length / 1000))} min read
                                    </span>
                                </>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Hero;
